import React from 'react';
import styled from 'styled-components';

export const StyledVersionContainer = styled.span`
	display: flex;
	flex-direction: column;
	color: ${({ theme }) => theme.colors.muted};
	font-size: 14px;
	bottom: 20px;
	padding-top: 30px;
`;

const FooterBar = () => (
	<div>
		<StyledVersionContainer>
			<span>Version {process.env.REACT_APP_VERSION}</span>
		</StyledVersionContainer>
	</div>
);

export default FooterBar;
